// decisions.ts — Patch 015.10. Decision-deadline methods.
//
// Per-project lead-time-aware decision tracking. Backend CRUD shipped under
// 011.D — see workers/core-os/src/routes/decisions.ts (migration 0036
// project_decisions). 015.10 adds the human surface (DecisionsPage).

import { request } from './request'
import type {
  CreateDecisionInput,
  DecisionListResponse,
  PatchDecisionInput,
  SeedDecisionTemplateResponse,
  UpcomingDecisionsResponse,
} from './types'

export const decisionsApi = {
  list: (projectId: string, params?: { status?: string }) => {
    const qs = new URLSearchParams()
    if (params?.status) qs.set('status', params.status)
    const suffix = qs.toString() ? `?${qs.toString()}` : ''
    return request<DecisionListResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/decisions${suffix}`,
    )
  },
  // Wave-7 D7 — cross-project upcoming decisions (pending, due within the
  // window; default 14 days, server-clamped 1..365).
  upcoming: (withinDays?: number) =>
    request<UpcomingDecisionsResponse>(
      `/api/decisions/upcoming${
        withinDays ? `?due_by_within_days=${withinDays}` : ''
      }`,
    ),
  create: (projectId: string, body: CreateDecisionInput) =>
    request<{
      ok: true
      id: string
      source_kind: string
      decision_due_by: string | null
      request_id: string
    }>(`/api/projects/${encodeURIComponent(projectId)}/decisions`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  update: (projectId: string, decisionId: string, body: PatchDecisionInput) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/projects/${encodeURIComponent(projectId)}/decisions/${encodeURIComponent(
        decisionId,
      )}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
  // Step 1c — materialize the Heritage standard decision template.
  seedTemplate: (projectId: string) =>
    request<SeedDecisionTemplateResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/decisions/seed-template`,
      { method: 'POST', body: '{}' },
    ),
}
